import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import Newsletter from "@/components/common/Newsletter";

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex flex-col max-w-3xl mx-auto w-full px-6 md:px-12">
        {children}
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
